module.exports = [
	10060,
	10085,
	10086,
	10011,
	10030,
	10037,
	10105,
	10096,
	10038,
	10076,
	10075,
	10074,
	10073,
	10059,
	10058,
	10014,
	10022,
	10069,
	10056,
	10068,
	10055,
	10024,
	10095,
	10067,
	10027,
	10099,
	10065,
	10043,
	10023,
	10084,
	10045,
	10032,
	10019,
	10090,
	10063,
	10049,
	10091,
	10057,
	10054,
	10072,
	10103,
	10015,
	10104,
	10110,
	10078,
	10033,
	10039,
	10016,
	10021,
	10109,
	10036,
	10077,
	10040,
	10026,
	10097,
	10046,
	10062,
	10052,
	10034,
	10013,
	10020,
	10050,
	10100,
	10025,
	10053,
	10047,
	10098,
	10051,
	10017,
	10018,
	10088,
	10102,
	10092,
	10089,
	10042,
	10101,
	10106,
	10081,
	10082,
	10066,
	10093,
	10070,
	10012,
	10079,
	10041,
	10064,
	10028,
	10107,
	10087,
	10094,
	10083,
	10031,
	10111,
	10048,
	10044,
	10035,
	10108,
	10071,
	10061,
	10029,
	10080
];


//////////////////
// WEBPACK FOOTER
// ./src/data/metroClusters.json
// module id = 278
// module chunks = 0